module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"back":"Catalog","choose_calculation":"Choose a calculation"},"fr":{"back":"Catalogue","choose_calculation":"Choisir un calcul"}}')
  delete Component.options._Ctor
}
